import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';
import HelpOutlineRounded from '@material-ui/icons/HelpOutlineRounded';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import fetch from "../../reduxLib/services/serviceHelpers";

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: 'absolute',
        top: 1,
        right: 1,
        color: theme.palette.text.main
    },
    popupContent: {
        position: 'relative',
        padding: theme.spacing(2.5),
        color: theme.palette.text.main
    },
    valueBox: {
        display: "inline-flex",
        alignItems: "center",
        gap: 10
    }

}));

const IconButtonElement = ({ onClick, className, testId, Icon, iconSize }) => {
    return (
        <IconButton onClick={onClick} size={iconSize} data-testid={testId} className={className ? className : null} >
            <Icon fontSize={iconSize} />
        </IconButton>
    );
};

const HelpPopover = ({
    value,
    Icon = HelpOutlineRounded,
    maxWidth = 500,
    iconSize = 'small',
    anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
    transformOrigin = { vertical: 'top', horizontal: value ? 'left' : 'center' },
    testId,
    children,
    onDataFetch,
    ...rest
}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const open = Boolean(anchorEl);
    const handleOpen = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setIsLoading(false);
    };
    const getEcomData = (e) => {
        setAnchorEl(e.currentTarget);
        setIsLoading(true);
        if (onDataFetch) {
            onDataFetch([], true);
        }
        new Promise((resolve, reject) =>{
            fetch(rest.endpoint, {
                method: "POST",
                body: {
                    searchStringList: [rest.deliveryNum]
                }
            })
            .then(response => {
                return response?.json() || {};
            })
            .then(result => {
                setIsLoading(false);
                const data = result[rest.deliveryNum];
                if (onDataFetch) {
                    onDataFetch(data, false);
                }
                resolve({
                    data: data
                });
            })
            .catch(err => {
                setIsLoading(false);
                if (onDataFetch) {
                    onDataFetch([], true);
                }
                reject(err);
            })
        })
    }

    return (
        <>
            {
                value ? <div className={classes.valueBox}>
                    <Typography>{value}</Typography>
                    <IconButtonElement Icon={Icon} onClick={getEcomData} testId={testId} iconSize={iconSize} />
                </div> :
                    <IconButtonElement Icon={Icon} onClick={handleOpen} testId={testId} iconSize={iconSize} />
            }

            <Popover
                data-testid="help-popover"
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
            >
                <Box p={2} maxWidth={maxWidth} className={classes.popupContent}>
                    <IconButtonElement Icon={CloseIcon} onClick={handleClose} testId="help-close" iconSize={iconSize} className={classes.closeButton} />
                    {/* pop up content */}
                    {React.isValidElement(children) ? React.cloneElement(children, { isLoading }) : children}
                </Box>
            </Popover>
        </>
    );
};

export default HelpPopover;
